export default __webpack_public_path__ + "bdcbc2b79e027d6acc3c084586dabb1d.png";